import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	place-items: center;

	& > svg {
		margin-bottom: 20px;
	}
`;

export const Title = styled.p`
	font-weight: 600;
	font-size: 14px;
	line-height: 22px;
	display: flex;
	align-items: center;
	text-align: center;
	color: ${tokens.color_gray_dark};
	margin-bottom: 8px;
`;

export const Description = styled.p`
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;
	color: ${tokens.color_gray_dark};
	margin-bottom: 24px;

	span {
		font-weight: 700;
	}
`;

export const ActionButtons = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	gap: 40px;
`;
